<template>
  <div>
    <el-table
    :data="tableData"
    stripe
    :height="tabH">
      <el-table-column
        v-for="col in cols"
        :key="col.prop"
        :prop="col.prop"
        :label="col.label"
        :width="col.width"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        key="edit"
        label="通过"
        width="80">
        <template v-if="col.prop == 'edit'" scope="scope">
          <el-button size="small" @click="edit(scope.row.guid,scope.row.createrGuid)"><i class="el-icon-edit"></i></el-button>
        </template>
      </el-table-column>
      <el-table-column
        key="del"
        label="关闭"
        width="80">
        <template v-if="col.prop == 'del'" scope="scope">
          <el-button size="small" @click="del(scope.row.guid,scope.row.createrGuid)"><i class="el-icon-delete"></i></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { openTeam, closeTeam } from '@/api/api_team.js'
  export default {
    data () {
      return {
        cols: [
          {
            prop: 'id',
            label: 'id',
            width: 80
          },
          {
            prop: 'guid',
            label: 'guid',
            width: 150
          },
          {
            prop: 'name',
            label: 'name',
            width: 150
          },
          {
            prop: 'createDate',
            label: 'createDate',
            width: 150
          },
          {
            prop: 'logo',
            label: 'logo',
            width: 150
          },
          {
            prop: 'introductions',
            label: 'introductions',
            width: 150
          },
          {
            prop: 'createrGuid',
            label: 'createrGuid',
            width: 150
          }
        ]
      }
    },
    props: ['tableData'],
    computed: {
      tabH () {
        return this.winH - (this.search ? this.search.getHeight() : 80) - 88
      }
    },
    methods: {
      showMsg (msg, type = 'warning') {
        this.$notify({
          title: '审核新团队',
          message: msg,
          type: type
        })
      },
      edit (guid, createrGuid) {
        console.log('open guid=' + guid)
        let data = {}
        data.teamGuid = guid
        data.createrGuid = createrGuid
        openTeam(data).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('已开通团队，请刷新更新。', 'info')
            } else {
              this.showMsg('开通团队失败1。', 'info')
            }
          } else {
            this.showMsg('开通团队失败2', 'info')
          }
        }).catch(err => {
          this.showMsg(`开通团队失败3 ${err}`)
        })
      },
      del (guid, createrGuid) {
        console.log('close guid=' + guid)
        let data = {}
        data.teamGuid = guid
        data.createrGuid = createrGuid
        closeTeam(data).then((res) => {
          if (res.data) {
            if (res.data.isOk === true) {
              this.showMsg('关闭成功，请刷新更新。', 'info')
            } else {
              this.showMsg('关闭团队失败1。', 'info')
            }
          } else {
            this.showMsg('关闭团队失败2', 'info')
          }
        }).catch(err => {
          this.showMsg(`关闭团队失败3 ${err}`)
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// newTeamTable.vue?4302df09